<template>
    <div class="d-flex flex-column p-2">
        <span class="font-md font-weight-bold text-gray-dk">Session expired</span>
        <span class="font-sm text-secondary mt-2 mb-3">Please try again to continue your payment or cancel and go back to store.</span>
        <div class="d-flex justify-content-end">
            <span class="font-sm font-weight-bold mr-3 text-gray text-capitalize clickable" @click="backToStore">Cancel</span>
            <span class="font-sm font-weight-bold text-success text-capitalize clickable" @click="tryAgain">Try Again</span>
        </div>
    </div>
</template>
<script>
export default {
    created() {
        let g4params = {
            'userId': sessionStorage.getItem("userId"),
            'cuid': sessionStorage.getItem("cuid"),
            'ip': sessionStorage.getItem("ip"),
            'user_agent': sessionStorage.getItem("user_agent"),
            'phone': sessionStorage.getItem("phone"),
            'operating_system': sessionStorage.getItem("operating_system"),
            'browser': sessionStorage.getItem("browser"),
            'transaction_type': sessionStorage.getItem("transaction_type"),
            'transaction_reference': sessionStorage.getItem("transaction_reference"),
        }       
        this.triggerG4Event('err_session_expired',g4params)
    },
    methods: {
        tryAgain() {
            let g4params = {
                'userId': sessionStorage.getItem("userId"),
                'cuid': sessionStorage.getItem("cuid"),
                'ip': sessionStorage.getItem("ip"),
                'user_agent': sessionStorage.getItem("user_agent"),
                'phone': sessionStorage.getItem("phone"),
                'operating_system': sessionStorage.getItem("operating_system"),
                'browser': sessionStorage.getItem("browser"),
                'transaction_type': sessionStorage.getItem("transaction_type"),
                'transaction_reference': sessionStorage.getItem("transaction_reference"),
            }       
            this.triggerG4Event('err_session_expired_click_try_again',g4params)
            // sessionStorage.clear();
            this.$attrs.options.promiseResolver();
            this.$listeners.close();
        },
        backToStore() {
            let g4params = {
                'userId': sessionStorage.getItem("userId"),
                'cuid': sessionStorage.getItem("cuid"),
                'ip': sessionStorage.getItem("ip"),
                'user_agent': sessionStorage.getItem("user_agent"),
                'phone': sessionStorage.getItem("phone"),
                'operating_system': sessionStorage.getItem("operating_system"),
                'browser': sessionStorage.getItem("browser"),
                'transaction_type': sessionStorage.getItem("transaction_type"),
                'transaction_reference': sessionStorage.getItem("transaction_reference"),
            }       
            this.triggerG4Event('err_session_expired_click_cancel',g4params)
            // sessionStorage.clear();
            this.$attrs.options.promiseRejecter();
            this.$listeners.close();
        },
        triggerG4Event(name, params = {}){
            if (typeof gtag === 'function'){
                gtag("event", name , params)
            } else{
                console.log('GTAG Func Not Defined')
            }
        }
    }
}
</script>